import { FunctionComponent } from 'react'
import styles from './deletePostDialog.module.scss'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import { useMutation } from '@apollo/client'
import { DELETE_POST } from '@/modules/API/news/news.ts'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { Close, Delete } from '@mui/icons-material'

interface DeletePostDialogProps {
    open: boolean
    handleClose: () => void
    postId: number
    daycareId: number
    refetch: () => void
}

const DeletePostDialog: FunctionComponent<DeletePostDialogProps> = ({
    open,
    handleClose,
    postId,
    daycareId,
    refetch
}: DeletePostDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deletePost] = useMutation(DELETE_POST, {
        variables: {
            postId: postId,
            daycareId: daycareId
        },
        onCompleted: () => {
            handleClose()
            showNotificationSuccess(t('postDeleted'))
            refetch()
        },
        onError: () => {
            showNotificationError(t('postNotDeleted'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.DialogDelete}>
            <DialogHeader title={t('deletePost')} />
            <DialogBody>
                <div className={styles.DialogContainer}>
                    <p className={styles.Text}>{t('deleteConfirm')}</p>
                    <p className={styles.Text}>{t('noRollBack')}</p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customIcon={<Delete />}
                        customText={t('yes')}
                        onClick={deletePost}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customIcon={<Close />}
                        customText={t('no')}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DeletePostDialog
